import React from "react";
import { useUniqueId } from "shared/uniqueId/useUniqueId";
import { Attribute } from "api/types/attribute";
import { SiteSurveyUnitAttribute } from "api/types/siteSurveyUnitAttribute";

interface TextAttributeType {
  attributeConfig: Attribute;
  attributeValue?: SiteSurveyUnitAttribute;
  onAttributeValueChange(attributeValueText: string): void;
}
export function TextAttribute({
  attributeConfig,
  attributeValue,
  onAttributeValueChange,
}: TextAttributeType) {
  const { uniquePrefix } = useUniqueId("textAttribute");
  function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    onAttributeValueChange(e.target.value);
  }

  function handleTextAreaOnChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    onAttributeValueChange(e.target.value);
  }

  const valueTmp = attributeValue?.attributeValue || "";
  return (
    <div className="mt-3">
      <label htmlFor={uniquePrefix} className="form-label">
        {attributeConfig.text}
      </label>
      {attributeConfig.multiline ? (
        <textarea
          rows={5}
          className="form-control"
          id={uniquePrefix}
          value={valueTmp}
          onChange={handleTextAreaOnChange}
        />
      ) : (
        <input
          type="text"
          className="form-control"
          id={uniquePrefix}
          value={valueTmp}
          onChange={handleOnChange}
        />
      )}
    </div>
  );
}
